import { render, staticRenderFns } from "./phonelogin.vue?vue&type=template&id=765ba7f6&"
import script from "./phonelogin.vue?vue&type=script&lang=js&"
export * from "./phonelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports